module.exports = __webpack_public_path__ + "b993cf4ca69cb2b594dd979aa1157294.pdf";